import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import Dropzone from "react-dropzone";

class UploadFile extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            nameFile: "",
            form: { file: {} },
            importStatus: "idle",
            skippedRows: [],
            resultMessage: "",
            errorMessage: "",
            createdCount: 0,
            skippedCount: 0
        };
        this.pollingInterval = null;
    }

    componentWillUnmount() {
        this.cleanup();
    }

    cleanup = () => {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    };

    handleFile = (archivo) => {
        archivo.map(file => (
            this.setState({
                form: { ...this.state.form, file: file },
                nameFile: file.path,
            })
        ));
    };

    HandleClickFile = () => {
        const file = this.state.form.file;
        if (!file || !file.name) return;

        if (!file.name.toLowerCase().endsWith('.xlsx')) {
            this.setState({ importStatus: "error", errorMessage: "Solo se permiten archivos .xlsx" });
            return;
        }

        this.setState({ importStatus: "uploading", errorMessage: "", resultMessage: "", skippedRows: [] });

        const formData = new FormData();
        formData.append("file", file);

        fetch(`/formatos/format_categories/${this.props.format_category.id}/formats/${this.props.format.id}/upload_file/${this.props.survey_parent_id}`, {
            method: 'POST',
            body: formData,
            headers: {}
        })
        .then(res => res.json())
        .then(data => {
            if (data.type === "processing") {
                this.setState({ importStatus: "processing" });
                this.startPolling();
            } else if (data.type === "error") {
                this.setState({ importStatus: "error", errorMessage: data.message });
            } else {
                this.setState({ importStatus: "completed", resultMessage: data.message });
                this.handleImportDone();
            }
        })
        .catch(error => {
            console.error("Error:", error);
            this.setState({ importStatus: "error", errorMessage: "Error al subir el archivo. Intente nuevamente." });
        });
    };

    startPolling = () => {
        if (this.pollingInterval) return;

        this.pollingInterval = setInterval(() => {
            fetch(`/formatos/format_categories/${this.props.format_category.id}/formats/${this.props.format.id}/import_progress/${this.props.format.id}`)
                .then(res => res.json())
                .then(data => {
                    if (!data || !data.status) return;

                    if (data.status === "processing") {
                        this.setState({ skippedRows: data.skipped_rows || [] });
                    } else if (data.status === "completed") {
                        this.setState({
                            importStatus: "completed",
                            createdCount: data.created_count,
                            skippedCount: data.skipped_count,
                            skippedRows: data.skipped_rows || [],
                            resultMessage: `${data.created_count} registro${data.created_count === 1 ? '' : 's'} creado${data.created_count === 1 ? '' : 's'} exitosamente.${data.skipped_count > 0 ? ` ${data.skipped_count} fila${data.skipped_count === 1 ? '' : 's'} omitida${data.skipped_count === 1 ? '' : 's'} por duplicados.` : ''}`
                        });
                        this.handleImportDone();
                        clearInterval(this.pollingInterval);
                        this.pollingInterval = null;
                    } else if (data.status === "error") {
                        this.setState({
                            importStatus: "error",
                            errorMessage: data.error_message || "Error en la importación."
                        });
                        clearInterval(this.pollingInterval);
                        this.pollingInterval = null;
                    }
                })
                .catch(err => console.error("Polling error:", err));
        }, 2000);
    };

    handleImportDone = () => {
        this.cleanup();
        setTimeout(() => { this.props.loadData(); }, 1000);
    };

    handleClose = () => {
        if (this.state.importStatus === "completed" || this.state.importStatus === "error" || this.state.importStatus === "idle") {
            this.cleanup();
            this.setState({
                form: { file: {} },
                nameFile: "",
                importStatus: "idle",
                skippedRows: [],
                resultMessage: "",
                errorMessage: "",
                createdCount: 0,
                skippedCount: 0
            });
            this.props.toggle();
        }
    };

    handleSubmit = e => { e.preventDefault(); };

    renderSkippedRows(skippedRows, skippedCount) {
        if (!skippedRows.length) return null;
        return (
            <div style={{ marginTop: '16px', background: '#fff8e1', borderRadius: '8px', padding: '12px 14px', border: '1px solid #ffe082' }}>
                <div style={{ fontSize: '12px', fontWeight: 600, color: '#e65100', marginBottom: '6px' }}>
                    <i className="fas fa-exclamation-triangle" style={{ marginRight: '6px' }}></i>
                    {skippedCount || skippedRows.length} fila{(skippedCount || skippedRows.length) === 1 ? '' : 's'} omitida{(skippedCount || skippedRows.length) === 1 ? '' : 's'} por duplicados
                </div>
                <ul style={{ margin: 0, paddingLeft: '18px', maxHeight: '100px', overflowY: 'auto', fontSize: '11px', color: '#795548' }}>
                    {skippedRows.map((s, i) => (
                        <li key={i}>Fila {s.row}: {s.reason}</li>
                    ))}
                </ul>
            </div>
        );
    }

    renderContent() {
        const { importStatus, nameFile, skippedRows, resultMessage, errorMessage, createdCount, skippedCount } = this.state;
        const isProcessing = importStatus === "uploading" || importStatus === "processing";

        return (
            <div>
                <style>{`
                    @keyframes importArrowBounce {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(6px); }
                    }
                    @keyframes importRowFill {
                        0%, 100% { background: #fafafa; }
                        30%, 70% { background: #e3f2fd; }
                    }
                    @keyframes importCellFill {
                        0%, 100% { background: #eee; }
                        30%, 70% { background: #90caf9; }
                    }
                    @keyframes importGlow {
                        0%, 100% { box-shadow: 0 0 5px rgba(30,136,229,0.3); }
                        50% { box-shadow: 0 0 15px rgba(30,136,229,0.6); }
                    }
                    @keyframes importPulse {
                        0%, 100% { transform: scale(1); opacity: 0.85; }
                        50% { transform: scale(1.06); opacity: 1; }
                    }
                    @keyframes importCheckPop {
                        0% { transform: scale(0); opacity: 0; }
                        60% { transform: scale(1.15); }
                        100% { transform: scale(1); opacity: 1; }
                    }
                    .bw-import-dropzone {
                        border: 2px dashed #c5cae9;
                        border-radius: 12px;
                        padding: 32px 20px;
                        text-align: center;
                        cursor: pointer;
                        transition: all 0.2s ease;
                        background: #fafbff;
                    }
                    .bw-import-dropzone:hover {
                        border-color: #1e88e5;
                        background: #e8f0fe;
                    }
                    .bw-import-dropzone.has-file {
                        border-color: #43a047;
                        background: #e8f5e9;
                    }
                `}</style>

                {/* Custom header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px 14px', borderBottom: '1px solid #eee' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: 'linear-gradient(135deg, #1b5e20, #43a047)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                <polyline points="14 2 14 8 20 8"/>
                                <line x1="8" y1="13" x2="16" y2="13"/>
                                <line x1="8" y1="17" x2="16" y2="17"/>
                                <polyline points="10 9 9 9 8 9"/>
                            </svg>
                        </div>
                        <div>
                            <div style={{ fontWeight: 600, fontSize: '15px', color: '#212121' }}>Importar desde Excel</div>
                            <div style={{ fontSize: '12px', color: '#888' }}>Archivos .xlsx - máx. 1000 filas</div>
                        </div>
                    </div>
                    {!isProcessing && (
                        <button onClick={this.handleClose} style={{ background: 'none', border: 'none', fontSize: '20px', color: '#999', cursor: 'pointer', padding: '0 4px', lineHeight: 1 }}>
                            &times;
                        </button>
                    )}
                </div>

                {/* Body */}
                <div style={{ padding: '20px 24px 24px' }}>

                    {/* === IDLE STATE === */}
                    {importStatus === "idle" && (
                        <div>
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', background: '#f0f7ff', borderRadius: '10px', padding: '12px 14px', marginBottom: '20px', border: '1px solid #d0e3f7' }}>
                                <i className="fas fa-info-circle" style={{ color: '#1e88e5', marginTop: '2px', fontSize: '14px', flexShrink: 0 }}></i>
                                <span style={{ fontSize: '12.5px', color: '#37474f', lineHeight: '1.45' }}>
                                    Antes de importar, descarga la <strong>plantilla</strong> desde el menú importar/exportar para asegurar el formato correcto de las columnas.
                                </span>
                            </div>

                            <Dropzone onDrop={(files) => this.handleFile(files)}>
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps({ className: `bw-import-dropzone${nameFile ? ' has-file' : ''}` })}>
                                        <input {...getInputProps()} />
                                        {!nameFile ? (
                                            <div>
                                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#90a4ae" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '10px' }}>
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                    <polyline points="17 8 12 3 7 8"/>
                                                    <line x1="12" y1="3" x2="12" y2="15"/>
                                                </svg>
                                                <p style={{ margin: '0 0 4px', color: '#546e7a', fontWeight: 500, fontSize: '14px' }}>
                                                    Arrastra tu archivo aquí
                                                </p>
                                                <p style={{ margin: 0, color: '#90a4ae', fontSize: '12px' }}>
                                                    o haz clic para seleccionarlo
                                                </p>
                                            </div>
                                        ) : (
                                            <div>
                                                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#43a047" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '8px' }}>
                                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                                    <polyline points="14 2 14 8 20 8"/>
                                                    <path d="M9 15l2 2 4-4"/>
                                                </svg>
                                                <p style={{ margin: 0, color: '#2e7d32', fontWeight: 500, fontSize: '13px', wordBreak: 'break-all' }}>
                                                    {nameFile}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Dropzone>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                                <button className="btn btn-light" onClick={this.handleClose} style={{ borderRadius: '8px', padding: '8px 20px', fontSize: '13px' }}>
                                    Cancelar
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => this.HandleClickFile()}
                                    disabled={!nameFile}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '8px 24px',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        background: nameFile ? 'linear-gradient(135deg, #1565c0, #1e88e5)' : '#ccc',
                                        border: 'none',
                                        opacity: nameFile ? 1 : 0.6
                                    }}
                                >
                                    <i className="fas fa-file-import" style={{ marginRight: '6px' }}></i>
                                    Importar
                                </button>
                            </div>
                        </div>
                    )}

                    {/* === UPLOADING STATE === */}
                    {importStatus === "uploading" && (
                        <div style={{ textAlign: 'center', padding: '30px 0' }}>
                            <div style={{ animation: 'importPulse 1.5s ease-in-out infinite' }}>
                                <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#1e88e5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                    <polyline points="17 8 12 3 7 8"/>
                                    <line x1="12" y1="3" x2="12" y2="15"/>
                                </svg>
                            </div>
                            <p style={{ marginTop: '14px', marginBottom: 0, color: '#455a64', fontWeight: 500, fontSize: '14px' }}>Subiendo archivo...</p>
                            <p style={{ margin: '4px 0 0', color: '#90a4ae', fontSize: '12px' }}>Esto puede tomar unos segundos</p>
                        </div>
                    )}

                    {/* === PROCESSING STATE === */}
                    {importStatus === "processing" && (
                        <div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '16px 0 8px' }}>
                                <div style={{ animation: 'importArrowBounce 1s ease-in-out infinite', marginBottom: '8px' }}>
                                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1e88e5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M12 3v14M5 12l7 7 7-7"/>
                                    </svg>
                                </div>
                                <div style={{ border: '2px solid #1e88e5', borderRadius: '8px', overflow: 'hidden', width: '200px', background: '#fff', animation: 'importGlow 2s ease-in-out infinite' }}>
                                    <div style={{ display: 'flex', background: '#1e88e5', padding: '5px 0' }}>
                                        {[1,2,3,4].map(c => (
                                            <div key={c} style={{ flex: 1, height: '5px', margin: '0 5px', background: 'rgba(255,255,255,0.5)', borderRadius: '3px' }} />
                                        ))}
                                    </div>
                                    {Array.from({ length: 7 }, (_, i) => (
                                        <div key={i} style={{ display: 'flex', padding: '2.5px 0', borderBottom: i < 6 ? '1px solid #eeeeee' : 'none', animation: `importRowFill 2.4s ease-in-out ${i * 0.28}s infinite` }}>
                                            {[1,2,3,4].map(c => (
                                                <div key={c} style={{ flex: 1, height: '4px', margin: '0 5px', borderRadius: '2px', animation: `importCellFill 2.4s ease-in-out ${i * 0.28}s infinite` }} />
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <p style={{ textAlign: 'center', color: '#455a64', fontWeight: 500, fontSize: '14px', margin: '12px 0 2px' }}>
                                Importando registros...
                            </p>
                            <p style={{ textAlign: 'center', color: '#90a4ae', fontSize: '12px', margin: 0 }}>
                                No cierres esta ventana
                            </p>
                            {this.renderSkippedRows(skippedRows)}
                        </div>
                    )}

                    {/* === COMPLETED STATE === */}
                    {importStatus === "completed" && (
                        <div style={{ textAlign: 'center', padding: '24px 0 8px' }}>
                            <div style={{ animation: 'importCheckPop 0.5s ease forwards' }}>
                                <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#e8f5e9', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#43a047" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M20 6L9 17l-5-5"/>
                                    </svg>
                                </div>
                            </div>
                            <p style={{ marginTop: '16px', fontWeight: 600, color: '#2e7d32', fontSize: '16px', marginBottom: '4px' }}>
                                {createdCount} registro{createdCount === 1 ? '' : 's'} importado{createdCount === 1 ? '' : 's'}
                            </p>
                            {resultMessage && (
                                <p style={{ color: '#78909c', fontSize: '12.5px', margin: '0 0 4px' }}>{resultMessage}</p>
                            )}
                            {this.renderSkippedRows(skippedRows, skippedCount)}
                            <button className="btn btn-light" onClick={this.handleClose} style={{ marginTop: '20px', borderRadius: '8px', padding: '8px 28px', fontSize: '13px', fontWeight: 500 }}>
                                Cerrar
                            </button>
                        </div>
                    )}

                    {/* === ERROR STATE === */}
                    {importStatus === "error" && (
                        <div style={{ textAlign: 'center', padding: '24px 0 8px' }}>
                            <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#ffebee', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#e53935" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"/>
                                    <line x1="6" y1="6" x2="18" y2="18"/>
                                </svg>
                            </div>
                            <p style={{ marginTop: '16px', fontWeight: 600, color: '#c62828', fontSize: '15px', marginBottom: '4px' }}>
                                Error en la importación
                            </p>
                            <p style={{ color: '#78909c', fontSize: '12.5px', margin: 0, padding: '0 10px' }}>{errorMessage}</p>
                            <button className="btn btn-light" onClick={this.handleClose} style={{ marginTop: '20px', borderRadius: '8px', padding: '8px 28px', fontSize: '13px', fontWeight: 500 }}>
                                Cerrar
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { importStatus } = this.state;
        const isProcessing = importStatus === "uploading" || importStatus === "processing";

        return (
            <Modal
                isOpen={this.props.modal}
                toggle={isProcessing ? undefined : this.handleClose}
                className="modal-dialog-centered"
                backdrop={isProcessing ? "static" : this.props.backdrop}
                contentClassName="border-0 shadow"
                style={{ maxWidth: '440px' }}
            >
                <ModalBody className="p-0">
                    {this.renderContent()}
                </ModalBody>
            </Modal>
        );
    }
}

export default UploadFile;
